
//公共组件
import Warehouse from './Warehouse'
import Supplier from './Supplier'
import Buyer from './Buyer'
import Business from './Business'
import Rjkj_Currency from './Currency'
import Cascader_Address from './Cascader_Address'
import Product from './Product'
import Export from './Export'
import System from './System'


export const _rjkjCompents= {System,Export,Warehouse,Cascader_Address,Supplier,Business,Buyer,Rjkj_Currency,Product} ;




//公共方法
//日期格式化处理dataFormat（data  ， 'yyyy-MM-DD'）
import dataFormat from './methods/format'
import gotop from './methods/gotop'
import getAttr from './methods/getAttr'


import * as utilsMethods from './utils/common'
export const _rjkjMethods= {dataFormat,gotop,getAttr,...utilsMethods} ;

